









































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchListShexiang extends Vue {
  @Prop()
  private detail: any;
  private cPart: any = "舌象信息输出";
  private detailChange() {
    this.$emit("update:detail", this.detail);
  }
  private get message() {
    return this.detail.data;
  }
  /**
   * @description 改变显示模块
   */
  private changePart(part) {
    this.cPart = part;
  }
}
